export default __webpack_public_path__ + "static/media/difference-between-gatsbyjs-and-nextjs.3e5afc22.md";